import React, { useEffect, useState } from "react";

import axios from "axios";
import exportValue from "../../apiconfig";
import { Card, Table, Button, Form } from "react-bootstrap";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import Swal from "sweetalert2";

const PayoutPreview = () => {
  const [customers, setCustomers] = useState([]);

  const [settleDate, setSettleDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };

  useEffect(() => {
    getPreview();
  }, []);

  const getPreview = async () => {
    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/preview_payout`;
      let sendData = {};
      const response = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });

      if (response.data.status) {
        let data = response.data.data.map((customer) => ({
          ...customer,
          customer_checked: true,
          shipments: customer.shipments.map((shipment) => ({
            ...shipment,
            checked: true,
          })),
        }));

        setCustomers(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const toggleShipment = (customerIndex, shipmentIndex) => {
    let updated = [...customers];

    updated[customerIndex].shipments[shipmentIndex].checked =
      !updated[customerIndex].shipments[shipmentIndex].checked;

    updated[customerIndex].customer_checked = updated[
      customerIndex
    ].shipments.some((x) => x.checked);

    recalculateCustomer(updated, customerIndex);

    setCustomers(updated);
  };

  const recalculateCustomer = (updated, customerIndex) => {
    let customer = updated[customerIndex];

    let selectedShipments = customer.shipments.filter((x) => x.checked);

    let totalCod = selectedShipments.reduce(
      (sum, item) => sum + Number(item.cod_amount || 0),
      0
    );

    let walletAdjustment = 0;

    if (customer.wallet_balance < 0) {
      walletAdjustment = Math.min(totalCod, Math.abs(customer.wallet_balance));
    }

    customer.total_cod_amount = totalCod;

    customer.wallet_adjustment = walletAdjustment;

    customer.estimated_payout = totalCod - walletAdjustment;
  };

  // const generatePayout = async () => {

  //     try {

  //       /*
  //       =========================================
  //       VALIDATE SETTLE DATE
  //       =========================================
  //       */

  //       if (!settleDate) {

  //         Swal.fire({
  //           icon: "error",
  //           title: "Settle Date Required",
  //           text: "Please select settle date",
  //         });

  //         return;
  //       }

  //       /*
  //       =========================================
  //       PREPARE CUSTOMERS
  //       =========================================
  //       */

  //       let selectedCustomers =
  //         customers
  //           .map((customer) => {

  //             let selected_awbs =
  //               customer.shipments
  //                 .filter(
  //                   (x) => x.checked
  //                 )
  //                 .map(
  //                   (x) => x.carrier_tracking_number
  //                 );

  //             return {
  //               customer_id:
  //                 customer.customer_id,

  //               selected_awbs,
  //             };
  //           })

  //           // remove empty customers
  //           .filter(
  //             (customer) =>
  //               customer.selected_awbs.length > 0
  //           );

  //       /*
  //       =========================================
  //       VALIDATE SHIPMENTS
  //       =========================================
  //       */

  //       if (!selectedCustomers.length) {

  //         Swal.fire({
  //           icon: "error",
  //           title: "No Shipment Selected",
  //           text:
  //             "Please select at least one shipment",
  //         });

  //         return;
  //       }

  //       /*
  //       =========================================
  //       TOTAL SHIPMENT COUNT
  //       =========================================
  //       */

  //       let totalShipments =
  //         selectedCustomers.reduce(
  //           (sum, customer) =>
  //             sum +
  //             customer.selected_awbs.length,
  //           0
  //         );

  //       /*
  //       =========================================
  //       CONFIRMATION
  //       =========================================
  //       */

  //       let confirm =
  //         await Swal.fire({

  //           icon: "warning",

  //           title:
  //             "Generate Payout?",

  //           html:
  //             `
  //             <div>
  //               <b>Total Customers:</b> ${selectedCustomers.length}
  //               <br/>
  //               <b>Total Shipments:</b> ${totalShipments}
  //             </div>
  //             `,

  //           showCancelButton: true,

  //           confirmButtonText:
  //             "Yes, Generate",

  //           cancelButtonText:
  //             "Cancel",
  //         });

  //       if (!confirm.isConfirmed) {
  //         return;
  //       }

  //       /*
  //       =========================================
  //       LOADING
  //       =========================================
  //       */

  //       setLoading(true);

  //       /*
  //       =========================================
  //       API
  //       =========================================
  //       */

  //       let full_api =
  //         exportValue.host +
  //         "/" +
  //         exportValue.version +
  //         "/" +
  //         exportValue.api +
  //         `/generate_payout`;

  //       /*
  //       =========================================
  //       PAYLOAD
  //       =========================================
  //       */

  //       let payload = {

  //         settle_date: settleDate,

  //         customers:
  //           selectedCustomers,
  //       };

  //       /*
  //       =========================================
  //       API CALL
  //       =========================================
  //       */

  //       const response =
  //         await axios.post(
  //           full_api,
  //           payload,
  //           {
  //             headers:
  //               exportValue.headers,
  //           }
  //         );

  //       /*
  //       =========================================
  //       RESPONSE
  //       =========================================
  //       */

  //       if (response.data.status) {

  //         await Swal.fire({
  //           icon: "success",
  //           title: "Good Job",
  //           text:
  //             response.data.message,
  //         });

  //         /*
  //         =====================================
  //         REFRESH PAGE DATA
  //         =====================================
  //         */

  //         getPreview();

  //       } else {

  //         Swal.fire({
  //           icon: "error",
  //           title: "Failed",
  //           text:
  //             response.data.message,
  //         });
  //       }

  //     } catch (e) {

  //       console.log(e);

  //       Swal.fire({

  //         icon: "error",

  //         title:
  //           "Something went wrong",

  //         text:
  //           e?.response?.data?.message ||
  //           "Server Error",
  //       });

  //     } finally {

  //       setLoading(false);
  //     }
  //   };

  const toggleCustomer = (customerIndex) => {
    let updated = [...customers];

    updated[customerIndex].customer_checked =
      !updated[customerIndex].customer_checked;

    updated[customerIndex].shipments = updated[customerIndex].shipments.map(
      (shipment) => ({
        ...shipment,
        checked: updated[customerIndex].customer_checked,
      })
    );

    recalculateCustomer(updated, customerIndex);

    setCustomers(updated);
  };

  const toggleAllShipments = (customerIndex) => {
    let updated = [...customers];

    let allSelected = updated[customerIndex].shipments.every((x) => x.checked);

    updated[customerIndex].shipments = updated[customerIndex].shipments.map(
      (shipment) => ({
        ...shipment,
        checked: !allSelected,
      })
    );

    updated[customerIndex].customer_checked = !allSelected;

    recalculateCustomer(updated, customerIndex);

    setCustomers(updated);
  };
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section class="home-section">
        <Sub_header />

        <div className="container-fluid">
          {/* <Card className="mb-3">
  
          <Card.Body>
  
            <div className="row">
  
              <div className="col-md-3">
  
                <label>
                  Settle Date
                </label>
  
                <Form.Control
                  type="date"
                  value={settleDate}
                  onChange={(e) =>
                    setSettleDate(
                      e.target.value
                    )
                  }
                />
  
              </div>
  
              <div className="col-md-3 d-flex align-items-end">
  
                <Button
                  onClick={
                    generatePayout
                  }
                  disabled={loading}
                >
                  {
                    loading
                      ? "Generating..."
                      : "Generate Payout"
                  }
                </Button>
  
              </div>
  
            </div>
  
          </Card.Body>
  
        </Card> */}

          {customers.map((customer, index) => (
            <Card className="mb-4 mt-4" key={customer.customer_id}>
              <Card.Body>
                <div className="d-flex justify-content-between mb-3">
                  <div>
                    <div className="d-flex align-items-center mb-2">
                      <Form.Check
                        type="checkbox"
                        checked={customer.customer_checked}
                        onChange={() => toggleCustomer(index)}
                        label=""
                      />

                      <h5 className="ms-2 mb-0">{customer.customer_name}</h5>
                    </div>

                    <div>
                      Customer ID :{customer.customer_id}
                      <br />
                      <br /> JP ID : {customer.jp_id}
                    </div>

                    <Button
                      size="sm"
                      variant="outline-primary"
                      className="mt-2"
                      onClick={() => toggleAllShipments(index)}
                    >
                      {customer.shipments.every((x) => x.checked)
                        ? "Unselect All Shipments"
                        : "Select All Shipments"}
                    </Button>
                  </div>

                  <div>
                    <div>Total COD: ₹{customer.total_cod_amount}</div>

                    <div>Wallet Adjustment: ₹{customer.wallet_adjustment}</div>

                    <div>Final Payout: ₹{customer.estimated_payout}</div>
                  </div>
                </div>

                <Table bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Select</th>

                      <th>AWB</th>

                      <th>COD Amount</th>

                      <th>Delivered Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {customer.shipments.map((shipment, sIndex) => (
                      <tr key={shipment.carrier_tracking_number}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            checked={shipment.checked}
                            onChange={() => toggleShipment(index, sIndex)}
                          />
                        </td>

                        <td>{shipment.carrier_tracking_number}</td>

                        <td>₹{shipment.cod_amount}</td>

                        <td>{shipment.delivery_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export default PayoutPreview;
